import { createSlice } from '@reduxjs/toolkit';

function detectMobile() {
  const userAgent = navigator.userAgent || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  return isAndroid || isIOS;
}

const userDataSlice = createSlice({
  name: 'userData',
  initialState: {
    userData: {},
    viewedStartUpMessages: null,
    hideDownloadApp: !detectMobile()
    ? true
    : JSON.parse(localStorage.getItem('hideDownloadApp')),
  },
  reducers: {
    setUserData(state, action) {
      state.userData = action.payload;
    },
    setViewedStartUpMessages(state, action) {
      state.viewedStartUpMessages = action.payload;
    },
    setHideDownloadApp(state, action) {
      state.hideDownloadApp = action.payload;
      localStorage.setItem('hideDownloadApp', JSON.stringify(action.payload));
    },
  },
});

export const { setUserData, setHideDownloadApp, setViewedStartUpMessages } = userDataSlice.actions;

export default userDataSlice.reducer;